import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Link } from "react-router-dom";
import { PrinterOutlined } from '@ant-design/icons';
import { Typography, Popconfirm } from 'antd';
import SearchTable from './SearchTable'
import { PRINTERS_PATH } from '../utils/constants';
import { compareStrings } from '../utils/utils';

const messages = defineMessages({
    DeleteConfirm: {
      id: 'DeleteConfirm',
    },  
});

const layout = {
    bordered : false,
    showSizeChanger : true, 
    pagination : {pageSize: 100, showSizeChanger: false},
    size: "small",
    rowKey : record => record.id,
};

const PrintersTable = (props) => {

    const intl = useIntl();
    const columns = [   
        {
            title: <FormattedMessage id="Enabled"/>,
            dataIndex: 'enabled',
            
            width: 50,
            sorter: {
            compare: (a, b) => a.enabled - b.enabled,
            },
            filters: [
                { text: <FormattedMessage id="Yes"/>, value: 1 },
                { text: <FormattedMessage id="No"/>, value: 0 },
              ],
            filterMultiple: false,
            onFilter: (value, record) => {
                if (value === 1) {
                    return record.enabled === 1;
                }
                else {
                    return record.enabled !== 1;
                }
            },
            render: (_, record) => {
                if (record.enabled)
                {
                    return(<PrinterOutlined/>);
                }
    
                return (<></>);
            }
        },    
        {
            title: <FormattedMessage id="DeviceMetersTable.name"/>,
            dataIndex: 'prnName',
            
            width: 250,
            search: true,
            sorter: {
                compare: (a, b) => compareStrings(a.prnName, b.prnName),
            },
            render: (_, record) => {
                if (record.enabled === 1)
                {
                    const url = PRINTERS_PATH + "/" + record.id;
                    return(
                    <div>
                        <Link to={url}>{record.prnName}</Link>
                    </div>
                    );        
                }
                else
                {
                    return(<Typography.Text disabled>{record.prnName}</Typography.Text>);
                }
            }
        },
        {
            title: <FormattedMessage id="Server"/>,
            dataIndex: 'serverName',
            
            search: true,
            sorter: {
                compare: (a, b) => compareStrings(a.serverName, b.serverName)
            },
        },
        {
            title: <FormattedMessage id="SuppliesTable.comment"/>,
            dataIndex: 'prnComment',
               
            search: true,             
            sorter: {
                compare: (a, b) =>  compareStrings(a.prnComment, b.prnComment)
            },
        },
        {
            title: <FormattedMessage id="SuppliesTable.location"/>,
            dataIndex: 'prnLocation',
               
            search: true,             
            sorter: {
                compare: (a, b) =>  compareStrings(a.prnLocation, b.prnLocation)
            },
        },
        {
            title: <FormattedMessage id="HardwareTable.serial"/>,
            dataIndex: 'serialNumber',
               
            search: true,             
            sorter: {
                compare: (a, b) =>  compareStrings(a.serialNumber, b.serialNumber)
            },
        },
        {
            title: <FormattedMessage id="Action"/>,
            key: 'action',
            render: (_, record) =>
                      <Popconfirm title={intl.formatMessage(messages.DeleteConfirm)} onConfirm={() => props.onDelete(record.id)}>
                      <a href="#!"><FormattedMessage id="Delete"/></a>
                      </Popconfirm>
          },
    ];   
        
    return (
        <div className = "report-table">
            <SearchTable
                layout = {layout}
                type = "checkbox"
                initialSelection={props.selected_keys}
                onSelectChange={props.onSelectChange}
                columns={columns} 
                dataSource={props.data} 
            />
        </div>
    );
}

export default PrintersTable;
